produtos.component('produtos.conteudos.sessaoModalComponent', {
    templateUrl: 'produtos/produtoDetalhes/conteudos/sessaoModal/sessaoModal.html',
    controller: 'produtos.sessaoModalController',
    controllerAs: '$modal',
    bindings: { config: '=' }
});

produtos.controller('produtos.sessaoModalController', [ '$scope', 'coreLanguage', function($scope, $text){
    const $ctrl = this;
    $scope.$text = $text;

    const formErrorsDefault = {
        nome:{},
        label:{},
        ordem:{}
    };

    $ctrl.onBlur = (field) => {
        if(!$ctrl.formErrors){ $ctrl.formErrors = angular.copy(formErrorsDefault); }

        $ctrl.formErrors[field] = {
            field: !$scope.formSessao[field].$valid,
            hint: !$scope.formSessao[field].$valid
        };
    };

    $ctrl.close=()=>{
        $ctrl.config.dados = {};
        $ctrl.config.show = false;
        $ctrl.formErrors = angular.copy(formErrorsDefault);
    };

    $ctrl.validateForm=()=>{

        if($scope.formSessao.$valid){
            $ctrl.config.confirm($ctrl.config.dados);
        }else{
            Object.keys(formErrorsDefault).forEach(key=>{ $ctrl.onBlur(key); });
        }

    };

}]);